import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    // Show banner if consent hasn't been set yet
    if (!this.hasConsent()) {
      this.bannerTarget.classList.remove("hidden")
    }
  }

  // Accept cookies
  accept() {
    this.setCookie("cookie_consent", "accepted", 365)
    this.bannerTarget.classList.add("hidden")
  }
  
  // Reject cookies
  reject() {
    this.setCookie("cookie_consent", "rejected", 365)
    this.bannerTarget.classList.add("hidden")
  }
  
  // Check if user has already made a cookie choice
  hasConsent() {
    return this.getCookie("cookie_consent") !== null
  }
  
  // Get cookie value by name
  getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(";").shift()
    return null
  }
  
  // Set cookie with expiration
  setCookie(name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = `expires=${date.toUTCString()}`
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`
  }
} 
